import React from "react";
import ChatBot from "../components/ChatBot";

const AIChatBot = () => {
    return (
        <div
            style={{
                minHeight: "100vh",
                backgroundColor: "#f4f6f9",
                padding: "30px",
            }}
        >
            <ChatBot />
        </div>
    );
};

export default AIChatBot;